import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

import "./McaCourse.css";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Accordion,
  Form,
} from "react-bootstrap";
import { FaCheckCircle, FaClock } from "react-icons/fa";

import { FaGraduationCap, FaBook } from "react-icons/fa";
import { FaLayerGroup } from "react-icons/fa";
import { FaChartLine, FaHandshake, FaUsers } from "react-icons/fa";
import Slider from "react-slick";
import { FaPlus, FaMinus } from "react-icons/fa"; // ✅ using react-icons
import {
  FaSnowflake,
  FaUser,
  FaDollarSign,
  FaBuilding,
  FaTruck,
  FaPhoneAlt,
} from "react-icons/fa";
import Admission from "../../components/Admission";
import Partner from "../../components/Partner";
import {
  FaChalkboardTeacher, // University Professor
  FaFlask, // Research Scientist
  FaMicroscope, // Postdoctoral Researcher
  FaBalanceScale, // Policy Analyst
  FaPenNib, // Academic Writer
  FaIndustry, // Corporate R&D Lead
  FaHandsHelping, // Project Head – NGOs
  FaUniversity, // Higher Education Administrator
} from "react-icons/fa";

export default function PhdCourse() {
  const careers = [
    {
      icon: <FaChalkboardTeacher size={40} color="#FF9800" />,
      title: "University Professor",
    }, // Orange
    {
      icon: <FaFlask size={40} color="#4CAF50" />,
      title: "Research Scientist",
    }, // Green
    {
      icon: <FaMicroscope size={40} color="#2196F3" />,
      title: "Postdoctoral Researcher",
    }, // Blue
    {
      icon: <FaBalanceScale size={40} color="#9C27B0" />,
      title: "Policy Analyst",
    }, // Purple
    { icon: <FaPenNib size={40} color="#E91E63" />, title: "Academic Writer" }, // Pink
    {
      icon: <FaIndustry size={40} color="#607D8B" />,
      title: "Corporate R&D Lead",
    }, // Grey-blue
    {
      icon: <FaHandsHelping size={40} color="#009688" />,
      title: "Project Head – NGOs",
    }, // Teal
    {
      icon: <FaUniversity size={40} color="#3F51B5" />,
      title: "Higher Education Administrator",
    }, // Indigo
  ];
  const universities = [
    {
      name: "Subharti University",
      logo: "/images/subharti.png",
    },
    {
      name: "IGNOU",
      logo: "/images/ignou.png",
    },
    {
      name: "Andhra University",
      logo: "/images/andhra.png",
    },
    {
      name: "Amity University",
      logo: "/images/amity.png",
    },
    {
      name: "Lovely Professional University (LPU)",
      logo: "/images/lpu.png",
    },
    {
      name: "Sikkim Manipal University",
      logo: "/images/smu.png",
    },
    {
      name: "Chandigarh University",
      logo: "/images/chandigarh.png",
    },
    {
      name: "Jain University",
      logo: "/images/jain.png",
    },
    {
      name: "Annamalai University",
      logo: "/images/annamalai.png",
    },
    {
      name: "Delhi University (School of Open Learning)",
      logo: "/images/du.png",
    },
    {
      name: "Madras University",
      logo: "/images/madras.png",
    },
  ];

  const highlights = [
    {
      icon: "⏰",
      title: "Course Duration",
      description:
        "2 years (4 semesters) — designed for efficient learning while balancing work or other commitments.",
    },
    {
      icon: "📚",
      title: "Learning Mode",
      description:
        "Distance / Online — study from anywhere with access to online classes, study material, and recorded lectures.",
    },
    {
      icon: "🔍",
      title: "Eligibility",
      description:
        "A bachelor's degree (preferably BCA, B.Sc CS/IT) with Mathematics in 10+2 or graduation.",
    },
    {
      icon: "🏛️",
      title: "University Recognition",
      description:
        "Courses offered are from UGC and AICTE-approved universities, ensuring your degree is valid and recognized.",
    },
    {
      icon: "📖",
      title: "Curriculum",
      description:
        "Covers core programming, software engineering, DBMS, networking, cloud computing, and more.",
    },
    {
      icon: "🎧",
      title: "Support & Flexibility",
      description:
        "Study on your schedule with weekend sessions, recorded classes, student support, and online doubt-solving.",
    },
  ];

  const steps = [
    {
      num: "1",
      title: "Fill the Application Form",
      text: "Establishing goals & blueprints for the new website",
      icon: "🔍",
    },
    {
      num: "2",
      title: "Document Verification",
      text: "Defining information architecture & content plan",
      icon: "📝",
    },
    {
      num: "3",
      title: "Confirm Admission & Pay Fees",
      text: "Designing the form & function of the website",
      icon: "🎨",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const data = [
    { icon: <FaChartLine />, number: "100%", label: "Success Rate" },
    { icon: <FaHandshake />, number: "35+", label: "Years Of Service" },
    { icon: <FaUsers />, number: "8k+", label: "Students" },
    { icon: <FaBook />, number: "10+", label: "Courses" },
  ];

  const plans = [
    {
      id: "01",
      color: "#00c6ff",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "02",
      color: "#2ecc71",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "03",
      color: "#f1c40f",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "04",
      color: "#e67e22",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "05",
      color: "#9b59b6",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "06",
      color: "#2980b9",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
  ];

  const blogs = [
    {
      title: "Writing Class",
      image: "https://via.placeholder.com/400x250?text=Writing+Class",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Crafts Activities",
      image: "https://via.placeholder.com/400x250?text=Crafts+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Math Activities",
      image: "https://via.placeholder.com/400x250?text=Math+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
  ];

  const faqData = [
    {
      question: "Can I get direct Phd admission without entrance exams?",
      answer:
        "Yes! Many universities like Amity and LPU offer direct admission based on Master’s scores or industry experience. We’ll identify options for you.",
    },
    {
      question: "What If I miss the 2025 deadline?",
      answer:
        "We prioritize rolling admissions for institutes like BITS Pilani and Symbiosis. Late applicants get backup university options.",
    },
    {
      question: "How do you gurantee timely Phd completion?",
      answer:
        "Our milestone-based system includes thesis outlines, data analysis workshops, and 24/7 mentor access to resolve bottlenecks.",
    },
    {
      question: "Are scholarships available for international students?",
      answer:
        "Absolutely! We’ve helped 120+ students secure ICCR and DASA grants for Indian PhD programs.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const features = [
    {
      icon: <FaSnowflake />,
      title: "Flexible Research Schedule",
      details:
        "Conduct your research through online PhD courses in Bangalore or a PhD correspondence course in Bangalore without leaving your job or relocating.",
    },
    {
      icon: <FaUser />,
      title: "Access to Expert Mentors",
      details:
        "Work under experienced supervisors provided by UGC-approved PhD distance education and UGC-approved PhD online programs.",
    },
    {
      icon: <FaDollarSign />,
      title: "Cost-Effective Learning",
      details:
        " Save on full-time tuition and relocation costs while receiving high-quality academic support at distance PhD colleges in Bangalore.",
    },
    {
      icon: <FaBuilding />,
      title: "UGC/AICTE Approved Programs",
      details:
        " Earn a credible doctoral degree from accredited Indian universities, recognized in both academia and industry.",
    },
    {
      icon: <FaTruck />,
      title: "Focused Research Opportunities",
      details:
        " Choose your specialization and contribute original work in your field through best PhD distance learning colleges in Bangalore.",
    },
    {
      icon: <FaPhoneAlt />,
      title: "Self-Paced Learning with Expert Support",
      details:
        " Learn at your own speed while accessing mentorship, guidance, and doubt-solving sessions offered by the best online PhD colleges.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>PhD Distance Education in Bangalore | UGC Approved Online</title>
        <meta
          name="description"
          content="Enroll in UGC-approved PhD distance education in Bangalore. Explore the best online PhD courses, correspondence programs, and top distance learning colleges."
        />
      </Helmet>
      <div className="mca-course-page">
        {/* ===== MCA Course Header ===== */}
        <section className="mca-course-header py-5 text-white">
          <Container>
            <Row className="align-items-center">
              {/* MCA Course Info */}
              <Col md={7} className="mca-course-header-content">
                <span className="mca-course-badge badge bg-warning text-dark mb-3">
                  Live Classes
                </span>
                <h1 className="mca-course-title fw-bold mb-3">
                  Doctor of Philosophy{" "}
                </h1>
                <p className="mca-course-subtitle lead mb-3">
                  This MCA program is designed to build a strong foundation in
                  computer applications, programming, software development, and
                  IT management. You’ll gain advanced skills required for
                  careers in the tech industry.
                </p>
                <Button
                  variant="warning"
                  size="lg"
                  className="mca-course-enroll-btn fw-bold"
                >
                  Get admitted to the batch
                </Button>

                {/* MCA Course Rating */}
                <div className="mca-course-rating mt-3 d-flex align-items-center">
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <span className="ms-2">(4.8)</span>
                </div>
              </Col>

              {/* MCA Course Thumbnail */}
              <Col md={5} className="mca-course-header-thumbnail text-center">
                <img
                  src="/images/931874-removebg-preview.png"
                  alt="MCA Course Preview"
                  style={{ height: "400px", marginTop: "40px" }}
                />
              </Col>
            </Row>
          </Container>
        </section>

        <Container className="my-5">
          <Row className="justify-content-center text-center mb-5">
            <Col md={10} lg={8}>
              <h1 className="fw-bold display-6 mb-3 text-primary">
                Why PhD Admission Requires Careful Planning
              </h1>
              <p className="text-muted fs-5">
                Careful planning ensures a smooth admission process, financial
                stability, and timely graduation in your PhD journey.
              </p>
            </Col>
          </Row>

          <Row className="g-4">
            <Col md={4}>
              <Card className="h-100 shadow-lg border-0 rounded-4 text-center p-3">
                <FaCheckCircle className="text-success display-4 mb-3" />
                <Card.Title as="h3" className="h5 fw-semibold">
                  Avoid Rejection
                </Card.Title>
                <Card.Text className="text-muted">
                  Get expert support to meet all eligibility criteria,
                  documentation, and proposal requirements—boosting your chances
                  of admission on the first attempt.
                </Card.Text>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="h-100 shadow-lg border-0 rounded-4 text-center p-3">
                <FaGraduationCap className="text-info display-4 mb-3" />
                <Card.Title as="h3" className="h5 fw-semibold">
                  Secure Scholarships
                </Card.Title>
                <Card.Text className="text-muted">
                  Receive guidance in identifying and applying for merit-based
                  or government-funded scholarships, reducing the financial
                  burden of pursuing a PhD.
                </Card.Text>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="h-100 shadow-lg border-0 rounded-4 text-center p-3">
                <FaClock className="text-warning display-4 mb-3" />
                <Card.Title as="h3" className="h5 fw-semibold">
                  Graduate on Time
                </Card.Title>
                <Card.Text className="text-muted">
                  Stay on track with structured mentorship, timely progress
                  reviews, and academic support to complete your PhD
                  efficiently, without unnecessary delays.
                </Card.Text>
              </Card>
            </Col>
          </Row>
        </Container>

        <Container className="my-5">
          <Row className="justify-content-center">
            <Col md={10} lg={8}>
              <h1 className="fw-bold display-6 mb-4">
                Overcoming Common PhD Admission Challenges in India
              </h1>

              <div className="mb-4">
                <h3 className="h5 fw-semibold">Complex Eligibility Criteria</h3>
                <p className="text-muted fs-6">
                  PhD distance education and PhD distance education in Bangalore
                  require a minimum 55% in Master’s, passing entrance exams like
                  UGC-NET or GATE, and meeting university-specific requirements.
                  Enrolling in UGC-approved PhD distance education ensures your
                  degree is recognized and credible.
                </p>
              </div>

              <div className="mb-4">
                <h3 className="h5 fw-semibold">Vague Research Proposals</h3>
                <p className="text-muted fs-6">
                  Distance PhD colleges in Bangalore and best online PhD
                  colleges prioritize well-crafted research proposals. Clear,
                  focused proposals aligned with university standards enhance
                  your chances in online PhD courses in Bangalore.
                </p>
              </div>

              <div className="mb-4">
                <h3 className="h5 fw-semibold">Funding Challenges</h3>
                <p className="text-muted fs-6">
                  UGC-approved PhD online programs and best PhD distance
                  learning colleges in Bangalore offer guidance on scholarships,
                  grants, and fellowships to overcome financial hurdles during
                  your research.
                </p>
              </div>

              <div className="mb-4">
                <h3 className="h5 fw-semibold">Delayed Completion</h3>
                <p className="text-muted fs-6">
                  PhD correspondence courses in Bangalore provide structured
                  timelines, mentorship, and academic support to help students
                  complete their PhD on schedule, ensuring timely graduation and
                  career advancement.
                </p>
              </div>
            </Col>
          </Row>
        </Container>

        {/* ===== MCA Course Content Section ===== */}

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h2
              className="text-center fw-bold mb-4"
              style={{ fontSize: "2rem", color: "#333" }}
            >
              PhD Distance Education – Advance Your Academic and Research Career
            </h2>

            {/* Paragraphs */}
            <p
              className="mx-auto"
              style={{
                maxWidth: "1100px",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#6c757d",
              }}
            >
              PhD through distance or part-time mode is an excellent option for
              working professionals and scholars aiming to deepen their
              expertise, contribute to research, and advance in academia or
              industry. This flexible program allows you to pursue a doctoral
              degree without leaving your job or compromising personal
              commitments. Offered by UGC-approved universities, PhD distance
              programs cover various disciplines and provide structured research
              guidance, mentorship, and academic support. Whether you’re
              targeting a career in teaching, high-level consultancy,
              policy-making, or specialized research roles, a distance PhD helps
              you build credibility, knowledge, and recognition in your chosen
              field.
            </p>
          </Container>
        </section>

        <section className="why-section">
          <div className="why-head">
            <h1>Why Choose Phd via Distance Education?</h1>
          </div>
          <div className="why-container">
            {/* Left image */}
            <div className="why-image">
              <img
                src="/images/whychoose.jpg"
                alt="Why Choose Bangalore Distance Education for Your Phd Distance Education"
              />
            </div>

            {/* Right content */}
            <div className="why-content">
              <p className="section-text">
                Distance PhD programs, including PhD distance education and PhD
                distance education in Bangalore, are increasingly popular among
                working professionals and aspiring researchers. These programs
                allow learners to pursue advanced academic qualifications
                without disrupting their careers. Here’s why choosing a PhD
                through distance or part-time education is a smart move:
              </p>

              <div className="features-grid">
                {features.map((item, idx) => (
                  <div key={idx} className="feature-card">
                    <div className="feature-icon">{item.icon}</div>
                    <div>
                      <h3 className="feature-title">{item.title}</h3>
                      <p className="feature-text">{item.details}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Admission Process */}

        <Admission></Admission>

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h1 className="text-center mb-5">Career Opportunities After PhD</h1>
            <p
              className="text-center mb-5"
              style={{ color: "#666", fontSize: "16px" }}
            >
              Earning a PhD through distance or part-time education opens up a
              wide range of career opportunities in academia, research,
              policy-making, and industry leadership. With advanced expertise,
              original research contributions, and deep subject knowledge, PhD
              holders are highly valued in both public and private sectors.
            </p>

            {/* Career Grid */}
            <Row className="text-center">
              {careers.map((career, index) => (
                <Col key={index} xs={12} sm={6} md={3} className="mb-4">
                  <div style={{ fontSize: "67px" }}>{career.icon}</div>
                  <h6 className="fw-bold mt-3">{career.title}</h6>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <Partner></Partner>

        <Container className="my-5">
          <Row className="justify-content-center">
            <Col md={10} lg={8}>
              <h1 className="fw-bold display-6 mb-3">
                Take the Next Step with Our Distance PhD Program
              </h1>
              <p className="text-muted fs-5">
                Ready to elevate your academic journey and advance your career?
                Our Distance PhD program, including PhD distance education and
                PhD distance education in Bangalore, is designed for ambitious
                professionals and researchers who want to pursue doctoral
                studies without interrupting their current commitments. With
                flexible learning options through online PhD courses in
                Bangalore, PhD correspondence courses in Bangalore, and
                UGC-approved PhD distance education, you gain expert
                supervision, structured mentorship, and recognized accreditation
                from top universities. Whether your goal is a career in
                academia, high-level research, or industry leadership, our
                program equips you with the skills, knowledge, and credentials
                needed to succeed. Explore opportunities at best online PhD
                colleges, distance PhD colleges in Bangalore, and UGC-approved
                PhD online programs to ensure your doctorate journey is smooth
                and credible. Take the next step today and start your PhD
                journey with confidence at the best PhD distance learning
                colleges in Bangalore.
              </p>
            </Col>
          </Row>
        </Container>

        {/* Register Now */}

        <div className="event-wrapper">
          {/* Curved shape */}
          <div className="curve"></div>

          {/* Left section */}
          <div className="left-section">
            <br />
            <h2>WE APPRECIATE ALL YOU DO</h2>
            <h3>Take the Next Step with Our Distance PhD Program</h3>
            <p>
              Ready to elevate your academic journey and make a meaningful
              impact in your field? Our Distance PhD program is designed for
              ambitious professionals and researchers who want to pursue
              doctoral studies without putting their careers on hold. With
              flexible learning options, expert supervision, and recognized
              accreditation, you can achieve your academic goals on your terms.
              Whether you’re aiming for a career in academia, research, or
              industry leadership, this program equips you with the skills,
              knowledge, and credentials to succeed. Take the next step toward
              earning your doctorate—start your PhD journey with us today.
            </p>
          </div>

          {/* Right section */}
          <div className="right-section">
            <form className="form-card">
              <h2>Registration</h2>
              <hr className="divider" />

              <input type="text" placeholder="Full Name*" />
              <input type="email" placeholder="Email*" />
              <input type="number" name="" id="" placeholder="Phone" />

              <button type="submit" className="register-btn">
                Register
              </button>

              <p className="footer-note">Your perfect events registrations</p>
            </form>
          </div>
        </div>

        {/* FAQ */}
        <section className="faq-section py-5">
          <Container>
            <Row>
              <h1 className="text-center mb-5">
                Frequently Asked Questions (FAQ)
              </h1>
            </Row>

            <Row>
              {faqData.map((faq, index) => (
                <Col md={6} key={index} className="mb-4">
                  <div
                    className={`faq-card ${
                      openIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="faq-question">
                      <span>{faq.question}</span>
                      <span className="faq-icon">
                        {openIndex === index ? <FaMinus /> : <FaPlus />}
                      </span>
                    </div>
                    {openIndex === index && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
